import { makeStyles } from 'tss-react/mui';
export const SELECTED_ROW_ACTION_BANNER_Z_INDEX = 9;

const useStyles = makeStyles()((theme) => ({
  tableBanner: {
    position: 'relative',
    top: 0,
    left: 0,
    right: 0,
    zIndex: SELECTED_ROW_ACTION_BANNER_Z_INDEX,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `12px ${theme.new.spacing.medium} 12px ${theme.new.spacing.medium}`,
    background: theme.new.color.grey[700],
    color: theme.new.color.common.white,
    flexWrap: 'nowrap',
    [theme.breakpoints.down('lg')]: {
      borderRadius: theme.new.shape.borderRadius.medium,
      marginBottom: theme.new.spacing.medium,
    },
    button: {
      span: {
        color: `${theme.new.color.common.white}`,
      },
      '&:hover, &:focus': {
        backgroundColor: 'transparent',
      },
      '&:focus-visible': {
        backgroundColor: 'transparent',
        boxShadow: `0px 0px 0px 2px ${theme.new.color.common.white}, 0px 0px 0px 4px ${theme.new.color.brand[500]}`,
      },
      '& svg path': {
        stroke: `${theme.new.color.common.white} !important`,
      },
    },
    '& .select-counters-wrapper': {
      flex: '0 0 auto',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
        flex: 'unset',
      },
    },
    '& .actions-wrapper': {
      width: '100%',
      flexWrap: 'wrap',
      gap: theme.new.spacing.large,
    },
    '& .action-close': {
      marginLeft: 'auto',
      '& svg path': {
        stroke: theme.new.color.common.white,
      },
      '&:hover svg path, &:focus svg path': {
        stroke: theme.new.color.common.white,
      },
    },
  },
  tableBannerInner: {
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  flexAlignCenter: {
    flex: 1,
    alignItems: 'center',
  },
  divider: {
    margin: '0 8px',
    '&.MuiDivider-root': {
      alignSelf: 'stretch',
      backgroundColor: theme.new.color.grey[400],
      borderColor: theme.new.color.grey[400],
    },
    '&.MuiDivider-vertical': {
      width: '1px',
      height: 'auto',
      minHeight: '100%',
      borderRightWidth: '1px',
      borderLeftWidth: 0,
      borderTopWidth: 0,
      borderBottomWidth: 0,
    },
    '&.MuiDivider-flexItem': {
      alignSelf: 'stretch',
      height: 'auto',
    },
  },
  bannerActionLink: {
    textAlign: 'start',
    whiteSpace: 'nowrap',
    span: {
      color: `${theme.new.color.brand[400]} !important`,
    },
    '&:disabled': {
      cursor: 'not-allowed !important',
      opacity: 0.5,
      '&:hover': {
        backgroundColor: 'transparent !important',
      },
      '& span': {
        color: `${theme.new.color.grey[400]} !important`,
      },
    },
  },
  bannerActionContent: {
    textAlign: 'start',
    '&.custom-icon-colors': {
      '& svg path, & svg g path': {
        stroke: `${theme.new.color.common.white} !important`,
        fill: 'none !important',
      },
    },
    span: {
      color: `${theme.new.color.common.white} !important`,
    },
    '&:disabled': {
      cursor: 'not-allowed !important',
      opacity: 0.5,
      '&:hover': {
        backgroundColor: 'transparent !important',
      },
      '& span': {
        color: `${theme.new.color.grey[400]} !important`,
      },
      '&.custom-icon-colors': {
        '& svg': {
          '& path, & g path': {
            stroke: `${theme.new.color.grey[400]} !important`,
            fill: 'none !important',
          },
        },
      },
    },
  },
  entireTableMessage: {
    fontSize: '10px !important',
    lineHeight: '1.2 !important',
    '& span': {
      color: `${theme.new.color.grey[300]} !important`,
      fontSize: '10px !important',
      fontStyle: 'italic',
      lineHeight: '1.2 !important',
    },
    '&.MuiTypography-root': {
      fontSize: '10px !important',
      lineHeight: '1.2 !important',
    },
  },
  selectAllButton: {
    whiteSpace: 'normal',
    '& span': {
      color: `${theme.new.color.brand[300]} !important`,
    },
  },
  messageContainer: {
    padding: '4px 0',
    background: theme.new.color.grey[700],
    color: theme.new.color.common.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    borderTop: `1px solid ${theme.new.color.grey[600]}`,
    [theme.breakpoints.down('lg')]: {
      borderRadius: `0 0 ${theme.new.shape.borderRadius.medium} ${theme.new.shape.borderRadius.medium}`,
      marginBottom: theme.new.spacing.medium,
    },
  },
  infoIcon: {
    fontSize: '14px !important',
    color: `${theme.new.color.common.white} !important`,
    '& path': {
      fill: `${theme.new.color.common.white} !important`,
    },
  },
}));

export default useStyles;
